import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  detailedData: [],
  pagination: {
    currentPage: 1,
    pageSize: 10,
    totalCount: 0,
    totalPages: 1,
    hasNextPage: false,
    hasPrevPage: false
  },
  appliedFilters: {
    testType: "All",
    parameterType: "All", 
    commodity: "All",
    parameter: "All",
    sortBy: "compliance",
    sortOrder: "desc"
  }
};

const parameterAnalyticsDetailedSlice = createSlice({
  name: "parameterAnalyticsDetailed",
  initialState,
  reducers: {
    fetchDetailed: (state, action) => {
      state.loading = true;
      state.error = null;
      state.detailedData =  [];
      // state.pagination = {
      //   currentPage: 1,
      //   pageSize: 10,
      //   totalCount: 0,
      //   totalPages: 1,
      //   hasNextPage: false,
      //   hasPrevPage: false
      // };
      // state.appliedFilters = {};
    },
    fetchDetailedSuccess: (state, action) => {
      const { data, pagination, filters } = action.payload;
      state.loading = false;
      state.detailedData = Array.isArray(data) ? data : [];
      state.pagination = {
        currentPage: pagination?.currentPage || 1,
        pageSize: pagination?.limit || 10,
        totalCount: pagination?.totalCount || 0,
        totalPages: pagination?.totalPages || 1,
        hasNextPage: pagination?.hasNextPage || false,
        hasPrevPage: pagination?.hasPrevPage || false
      };
      if (filters) {
        state.appliedFilters = { ...state.appliedFilters, ...filters };
      }
    },
    fetchDetailedFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.detailedData = [];
      state.pagination.totalCount = 0;
      state.pagination.totalPages = 1;
    },
    clearError: (state) => {
      state.error = null;
    },
    setPagination: (state, action) => {
      const { currentPage, pageSize } = action.payload;
      state.pagination.currentPage = currentPage;
      if (pageSize) {
        state.pagination.pageSize = pageSize;
      }
    },
    setPageSize: (state, action) => {
      state.pagination.pageSize = action.payload;
      state.pagination.currentPage = 1; 
    },
    resetPagination: (state) => {
      state.pagination.currentPage = 1;
      state.pagination.pageSize = 10;
    },
    setFilters: (state, action) => {
      state.appliedFilters = { ...state.appliedFilters, ...action.payload };
      state.pagination.currentPage = 1; 
    },
    resetFilters: (state) => {
      state.appliedFilters = {
        testType: "All",
        parameterType: "All",
        commodity: "All", 
        parameter: "All",
        sortBy: "compliance",
        sortOrder: "desc"
      };
      state.pagination.currentPage = 1;
    },
  },
});

export const { actions, reducer } = parameterAnalyticsDetailedSlice;
export const sliceKey = parameterAnalyticsDetailedSlice.name;